import React from 'react';
import ButtonCmp from 'src/components/ButtonCmp';

interface IProps {
    handleActionType?: () => void;
    title: any;
    desc: string;
    containerClassName?: string;
    contentClassName?: string;
    iconClassName?: string;
    Icon?: any;
    buttonText?: string;
    buttonDisabled?: boolean;
    testId?: string;
    buttonClassName?: string;
    titleClassName?: string;
    descClassName?: string;
    buttonType?: string;
}

const Confirmation = ({
    handleActionType,
    title,
    desc,
    containerClassName = '',
    contentClassName = '',
    Icon = '',
    iconClassName = '',
    buttonText,
    buttonDisabled,
    testId,
    buttonClassName,
    titleClassName,
    descClassName,
    buttonType,
}: IProps) => (
    <div data-test-id={testId} className={`h-full flex items-center justify-center overflow-hidden ${containerClassName}`}>
        <div className={`${contentClassName} max-w-[480px] w-full flex items-center justify-center flex-col z-[0] relative mb-[38px]`}>
            <div
                className={`${iconClassName} rounded-full h-14 w-14 min-w-14 min-h-14 text-primary flex items-center justify-center mb-4 
        bg-[linear-gradient(180deg,_#F9FAFB_0%,_#E7EBEF_100%)]`}
            >
                {Icon}
            </div>

            <div className={`text-center text-grayLight900 text-lg font-semibold ${titleClassName} `}>{title}</div>
            <div className={`sm:max-w-[342px] p-1 text-center text-grayLight600 text-sm font-normal leading-normal ${descClassName} `}>{desc}</div>

            {handleActionType && buttonText && buttonText !== 'false' && (
                <ButtonCmp type="button" size="md" onClick={handleActionType} disabled={buttonDisabled} className={` w-full mt-[32px] ${buttonType ? buttonType : 'btn_primary'} ${buttonClassName}`}>
                    {buttonText}
                </ButtonCmp>
            )}
        </div>
    </div>
);

export default Confirmation;
